import * as React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

type AgentModerationStatus = "draft" | "pending" | "published" | "unpublished" | "rejected";

type PublishSettingsSectionProps = {
  status: AgentModerationStatus;
  visibility: "public" | "private" | "unlisted";
  onStatusChange: (status: AgentModerationStatus) => void;
  onVisibilityChange: (visibility: "public" | "private" | "unlisted") => void;
  publishDate?: string;
  onPublishDateChange?: (date: string) => void;
  author?: string;
  onAuthorChange?: (author: string) => void;
  authors?: Array<{ id: string; name: string }>;
};

export function PublishSettingsSection({
  status,
  visibility,
  onStatusChange,
  onVisibilityChange,
  publishDate,
  onPublishDateChange,
  author,
  onAuthorChange,
  authors = [],
}: PublishSettingsSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Publish Settings</h3>
      </div>
      <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Status
          </label>
          <Select value={status} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="draft">Draft</SelectItem>
              <SelectItem value="pending">Pending</SelectItem>
              <SelectItem value="published">Published</SelectItem>
              <SelectItem value="unpublished">Unpublished</SelectItem>
              <SelectItem value="rejected">Rejected</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Visibility
          </label>
          <Select value={visibility} onValueChange={onVisibilityChange}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="public">Public</SelectItem>
              <SelectItem value="private">Private</SelectItem>
              <SelectItem value="unlisted">Unlisted</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {onPublishDateChange && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Publish Date
            </label>
            <Input
              type="datetime-local"
              value={publishDate || ""}
              onChange={(e) => onPublishDateChange(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
        )}
        {onAuthorChange && authors.length > 0 && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Author
            </label>
            <Select value={author || ""} onValueChange={onAuthorChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {authors.map((a) => (
                  <SelectItem key={a.id} value={a.id}>
                    {a.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>
    </div>
  );
}